// extracted by mini-css-extract-plugin
export var columnList = "_hd-0";